module.exports = __webpack_public_path__ + "static/media/map-image.56646dd3.png";